import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { FieldLabel } from '@/components/Form/fields';
import InfoPopover from '@/components/InfoPopover';

type FilterFieldProps = ComponentPropsWithoutRef<'div'> & {
  label?: ReactNode;
  infoPopover?: { title?: ReactNode; body: ReactNode };
  hideLabel?: boolean;
};

const FilterField = ({ children, label, infoPopover, hideLabel, ...props }: FilterFieldProps) => (
  <div className="relative" {...props}>
    {!hideLabel && label && (
      <FieldLabel variant="medium">
        {label}
        {infoPopover && <InfoPopover title={infoPopover.title} body={infoPopover.body} />}
      </FieldLabel>
    )}
    {children}
  </div>
);

export default FilterField;
